export class HttpVerb {
  static GET = 'GET'
  static PUT = 'PUT'
  static HEAD = 'HEAD'
  static POST = 'POST'
  static PATCH = 'PATCH'
  static DELETE = 'DELETE'
  static OPTIONS = 'OPTIONS'
}
